<template>
  <div class="module">
    <div class="module-header">
      <i :class="`icon ${icon}`"></i>
      <span class="module-header-title">{{data.name}}</span>
      <EditButton class="module-header-button"
        v-if="!hideEditButton && isEditMode"
        @click="click"
        :lang="{
          edit: lang.click
        }"
      ></EditButton>
    </div>
    <div class="module-body" :style="bodyStyle">
      <slot></slot>
      <div class="module-body-footer" v-if="data.moreText">
        <BaseButton3 @click="more" style="width: 100px">{{data.moreText}}</BaseButton3>
      </div>
    </div>
  </div>
</template>

<script>
import env from '@/env.js'
import {
  BaseButton3,
  EditButton
} from '@/components'

export default {
  components: {
    BaseButton3,
    EditButton
  },
  props: {
    hideEditButton: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default () {
        return {
          click: '修改'
        }
      }
    },
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default () {
        return {
          name: '',
          icon: '',
          icon_body: '',
          moreText: ''
        }
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon () {
      if (this.data.icon) {
        return this.data.icon
      } else if (this.data.icon === null) {
        return ''
      }
      switch (this.index) {
        case 1:
          return 'icon-dc_phone_icon_inbox'
        case 2:
          return 'answer_small'
        case 0:
        default:
          return 'icon-pr_phone_icon_preference_small'
      }
    },
    bodyStyle () {
      let key
      if (this.data.icon_body) {
        key = this.data.icon_body
      } else if (this.data.icon_body === null) {
        return ''
      } else if (env.isMobile) {
        return ''
      } else {
        switch (this.index) {
          case 1:
            key = 'case_big'
            break
          case 2:
            key = 'answer_big'
            break
          case 0:
          default:
            key = 'preference_big'
        }
      }
      return `background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_icon_${key}.png')`
    }
  },
  methods: {
    click () { this.$emit('click') },
    more () { this.$emit('more') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.module {
  max-width: 1024px;
  @media (--mediaPc) {
    margin: 25px auto;
    border: 1px solid var(--colorGray4);
    border-radius: var(--borderRadius3);
  }
  @media (--mediaMobile) {
    padding: calc(40px / var(--scaleMobile)) 0;
    border-radius: var(--borderRadius3Mobile);
  }

  & .module-header {
    position: relative;
    width: 100%;
    @media (--mediaPc) {
      height: 40px;
      border-bottom: 1px solid var(--colorGray4);
      font-size: var(--textSize3);
    }
    @media (--mediaMobile) {
      height: calc(32px / var(--scaleMobile));
      font-size: var(--textSize2Mobile);
    }
    &::after {
      content: '';
      width: 0;
      height: 100%;
      display: inline-block;
      position: relative;
      vertical-align: middle;
    }
    & .icon {
      text-align: center;
      height: 100%;
      color: var(--color1);

      margin: 0;
      position: absolute;
      @media (--mediaPc) {
        top: 11px;
        width: 53px;
        padding-left: 5px;
        font-size: var(--textSize2);
      }
      @media (--mediaMobile) {
        top: 1px;
        width: 40px;
        padding-left: 4px;
      }
    }

    & .module-header-title {
      font-weight: bold;
      vertical-align: middle;
      @media (--mediaPc) {
        padding-top: 11px;
        margin-left: 53px;
      }
      @media (--mediaMobile) {
        padding-top: -1px;
        margin-left: 40px;
      }
    }

    & .module-header-button {
      float: right;
      @media (--mediaPc) {
        margin: 6px 20px;
      }
      @media (--mediaMobile) {
        margin: 0px 20px;
      }
    }
  }
  & .module-body {
    /* for icon */
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;

    @media (--mediaPc) {
      min-height: 140px;
    }
    @media (--mediaMobile) {
    }
    & .module-body-footer {
      padding: 25px 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/BaseModule.vue